// extracted by mini-css-extract-plugin
export default {"brandPromo":"xH-z","carousel":"yH-z"};